module.exports = __webpack_public_path__ + "img/Frame_purple.f3b56e93.png";